import React from 'react';
import ResourceRow from './ResourceRow';


const Resources = (props) => {

  let resourceData = props.resources.map((resource) => {
    return <ResourceRow name={resource.name}
                        address={resource.address}
                        city={resource.city}
                        phone={resource.phone}
                        details={resource.details}
                        services={resource.services} />

  });

  return (
    <table>
      <thead>
        <tr>
          <th id="agency">Agency</th>
          <th id="details">Details</th>
          <th id="other">Other Services</th>
        </tr>
      </thead>

      <tbody>
        {resourceData}       
      </tbody>
    </table> 
  );
}

export default Resources;